import { render, staticRenderFns } from "./AppCarouselConfig.vue?vue&type=template&id=1738ab21"
import script from "./AppCarouselConfig.vue?vue&type=script&lang=js"
export * from "./AppCarouselConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports